(function(angular) {
    /**
     * @ngdoc directive
     * @name GridTableBindCellController
     * @description Renders the grid table cell value of type GridTableViewDatasetRowValue by whether binding it as HTML or invoking it with the current cell $element so that the parent can append it.
     * Does not create a new scope, hence uses the attribute `grid-table-bind-cell` to find the value to be rendered from the parent scope.
     */
    class GridTableBindCellController {
        static get $inject() {
            return ['$element', '$filter', '$attrs', '$scope'];
        }

        constructor($element, $filter, $attrs, $scope) {
            this.$element = $element;
            this.$attrs = $attrs;
            this.$scope = $scope;
            this.$filter = $filter;
        }

        $postLink() {
            const cellValue = this.getCellValue();

            if (cellValue.transclude) {
                cellValue.value(this.$element);
            } else {
                this.$element.html(
                    this.$filter('htmlEntities')(cellValue.value, true) || ''
                );
            }
        }

        $onDestroy() {
            this.$element.empty();
        }

        /**
         * @ngdoc method
         * @name GridTableBindCellController#getCellValue
         * @description Retrieves the row value corresponding to the current grid cell
         * @returns {GridTableViewDatasetRowValue}
         */
        getCellValue() {
            const scopeProperty = this.$attrs.gridTableBindCell;

            return this.$scope[scopeProperty] || {
                hashKey: '',
                value: '',
                transclude: false
            };
        }
    }

    angular.module('wtUi.wtGridTable').directive('gridTableBindCell', function() {
        return {
            restrict: 'A',
            controller: GridTableBindCellController
        };
    });
})(window.angular);
